import {mapActions, mapGetters} from 'vuex'
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        Multiselect
    },

    props: ['referenceId', 'referenceType'],

    data() {
        return {
            subscribedContacts: [],
            dataLoaded: false,
            projectId: null
        }
    },

    computed: {
        ...mapGetters([
            'subscribedContactsByReference',
            'projectContactsByProjectId',
            'contacts',
            'taskById'
        ]),

        currentSubscribedContactsIds() {
            return this.subscribedContactsByReference(
                this.referenceType,
                this.referenceId
            )
        },

        isDirty() {
            return _.isEqual(
                this.currentSubscribedContactsIds,
                _.map(this.subscribedContacts, 'id')
            )
        }
    },

    methods: {
        ...mapActions(['updateSubscribedContacts', 'fetchContacts']),

        handleUpdate() {
            this.updateSubscribedContacts({
                subscribed_contacts: _.map(this.subscribedContacts, 'id'),
                reference_id: parseInt(this.referenceId),
                reference_type: this.referenceType
            }).then(() => this.$emit('submitting', false))
        }
    }
}
